import { useRef as UseRef, useEffect, useState } from "react";
import {
    TableContainer,
    Paper,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Typography,
    Button,
    Box,
    Grid,
    Divider,
    TextField
} from "@mui/material";
import { ArrowUpward, ArrowDownward, ArrowRightAltRounded } from "@mui/icons-material";
import MenuApp from '../../../components/Menu';
import { ThemeProvider } from '@mui/material/styles';
import fix from "../../../services/fix"
import CssBaseline from '@mui/material/CssBaseline';
import constants from '../../../utils/constants';
import PriceCell from "../../../components/PriceCell";
import FooterOperaciones from "../../../components/Footer";
import fixCon from "../../../services/fixCon"
import TokenService from "../../../services/security/token.service";
import AuthService from "../../../services/security/auth.service";
import informationService from '../../../services/system';

const PriceBoard = () => {
    const user = TokenService.getUser();
    const [prices, setPrices] = useState([]);
    const [list, setList] = useState([]);
    const [code, setCode] = useState('CS');
    const [filtersValues, setFiltersValues] = useState([]);
    const [tipoVencimiento24, setTipoVencimiento24] = useState(true);
    const [tipoVencimientoCdo, setTipoVencimientoCdo] = useState(false);
    const [precioFiltro, setPrecioFiltro] = useState(true);
    const boxRef = UseRef(null);
    const pricesRef = UseRef(prices);
    const [titleInfoMercado, setTittleInfoMercado] = useState('');
    const [listInfoMercado, setListInfoMercado] = useState([]);
    const [results, setResults] = useState([]);
    const [saldos, setSaldos] = useState([]);
    const [disponibles, setDisponibles] = useState([]);
    const [ultPrecio, setUltPrecio] = useState(0);
    const [variac, setVariac] = useState(0);
    const [selectSymbol, setSelectSymbol] = useState(null);
    const title = ["Especie", "Vto.", "Moneda", "C.Cpra.", "P.Cpra.", "P.Vta.", "C.Vta.", "Apertura", "Mínimo", "Máximo", "Último", "Cierre Ant.", "Cierre", "Dir.", "Var.", "Volumen", "Vol.Monto", "Vwap", "Hora"];
    const titleCauciones = ["Tip. Liq.", "Plazo", "Vto.", "Tasa Ult.", "Cant. Oper.", "Monto. Cdo.", "M. Tom.", "T. Tom.", "T. Col.", "M. Col.", "Vwap"];
    let fieldFilter = {};

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        const ws = new WebSocket(constants.FIXMDSOCKET);

        ws.onmessage = (event) => {
            const updatedPrices = JSON.parse(event.data);
            orderFix(updatedPrices, pricesRef.current, ws);
        };

        ws.onerror = (error) => {
            console.error("WebSocket Error:", error);
        };

        return () => {
            ws.close();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        pricesRef.current = prices;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [prices]);

    useEffect(() => {
        document.title = 'Cotizaciones - wBroker'
        pricesRef.current = prices;
        viewPrice('CS', ['Merval-Lideres'], 'CS');
        dayResults();
        saldosFc();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const orderFix = (newPrice, pricesRef, ws) => {
        let arrayPrices = pricesRef;

        // Iteramos sobre NoMDEntries
        let shouldUpdatePrices = false;

        newPrice.NoMDEntries.forEach(newEntry => {

            const mDEntryType = newEntry.MDEntryType;

            // Filtramos precios según el tipo de MDEntryType
            if (['0', '1'].includes(mDEntryType)) {

                if (!newEntry.priceList || !Array.isArray(newEntry.priceList)) {
                    return;
                }

                newEntry.priceList.forEach(priceListItem => {

                    const securityIdNewPrice = priceListItem.SecurityID;

                    const species = arrayPrices.find(
                        species => species.SecurityID === securityIdNewPrice
                    );

                    if (species) {

                        const existingEntry = species.NoMDEntries.find(
                            entry => entry.MDEntryType === mDEntryType
                        );

                        const positionDelete = priceListItem.MDEntryPositionNo;

                        species.time = new Date().toLocaleTimeString();

                        if (
                            priceListItem.MDEntryPx !== undefined &&
                            priceListItem.MDEntryPx !== null
                        ) {
                            species.lastMdEntryPx = priceListItem.MDEntryPx;
                        }

                        /*
                         * IMPORTANTE:
                         * La acción pertenece a cada elemento de priceList.
                         *
                         * FIX puede enviar dentro del mismo priceList:
                         *
                         * posición 1 -> INSERT
                         * posición 2 -> UPDATE
                         * posición 3 -> DELETE
                         *
                         * Por eso NO usamos:
                         *
                         * newEntry.MDUpdateAction
                         *
                         * sino:
                         *
                         * priceListItem.MDUpdateAction
                         */

                        const mdUpdateAction = Number(
                            priceListItem.MDUpdateAction
                        );

                        if (existingEntry) {

                            switch (mdUpdateAction) {

                                case 0: // INSERT

                                    {
                                        const newPriceEntry = {
                                            ...priceListItem
                                        };

                                        /*
                                         * Evitamos duplicar una posición
                                         * si eventualmente llega nuevamente
                                         * un INSERT para la misma posición.
                                         */
                                        const alreadyExists =
                                            existingEntry.priceList?.some(
                                                entry =>
                                                    entry.MDEntryPositionNo ===
                                                    priceListItem.MDEntryPositionNo
                                            );

                                        if (!alreadyExists) {

                                            existingEntry.priceList.push(
                                                newPriceEntry
                                            );

                                            existingEntry.priceList.sort(
                                                (a, b) =>
                                                    a.MDEntryPositionNo -
                                                    b.MDEntryPositionNo
                                            );

                                        } else {

                                            /*
                                             * Si ya existe la posición,
                                             * actualizamos el registro.
                                             */
                                            const entryToUpdate =
                                                existingEntry.priceList.find(
                                                    entry =>
                                                        entry.MDEntryPositionNo ===
                                                        priceListItem.MDEntryPositionNo
                                                );

                                            if (entryToUpdate) {
                                                Object.assign(
                                                    entryToUpdate,
                                                    priceListItem
                                                );
                                            }
                                        }

                                        if (
                                            priceListItem.MDEntryPositionNo === 1
                                        ) {
                                            shouldUpdatePrices = true;
                                        }
                                    }

                                    break;


                                case 2: // DELETE

                                    {
                                        const initialLength =
                                            existingEntry.priceList.length;

                                        existingEntry.priceList =
                                            existingEntry.priceList.filter(
                                                entry =>
                                                    entry.MDEntryPositionNo !==
                                                    positionDelete
                                            );

                                        if (
                                            initialLength !==
                                            existingEntry.priceList.length &&
                                            positionDelete === 1
                                        ) {
                                            shouldUpdatePrices = true;
                                        }

                                        /*
                                         * Mantengo la lógica original
                                         * de renumeración.
                                         */
                                        existingEntry.priceList.forEach(
                                            (entry, index) => {

                                                if (
                                                    entry.MDEntryPositionNo >
                                                    positionDelete
                                                ) {
                                                    entry.MDEntryPositionNo -= 1;
                                                }

                                            }
                                        );
                                    }

                                    break;


                                case 1: // UPDATE

                                    {
                                        const entryToUpdate =
                                            existingEntry.priceList.find(
                                                entry =>
                                                    entry.MDEntryPositionNo ===
                                                    priceListItem.MDEntryPositionNo
                                            );

                                        if (entryToUpdate) {

                                            entryToUpdate.previousMDEntryPx =
                                                entryToUpdate.MDEntryPx;

                                            entryToUpdate.previousMDEntrySize =
                                                entryToUpdate.MDEntrySize;


                                            let ultimoPrecio =
                                                species.lastMdEntryPx
                                                    ? species.lastMdEntryPx
                                                    : '0';

                                            ultimoPrecio =
                                                ultimoPrecio
                                                    .toString()
                                                    .replace(/\./g, '');

                                            ultimoPrecio =
                                                ultimoPrecio
                                                    .toString()
                                                    .replace(/,/g, '.');

                                            ultimoPrecio =
                                                Number(ultimoPrecio).toFixed(2);


                                            const mdEntrye =
                                                species.NoMDEntries.find(
                                                    e =>
                                                        e.MDEntryType === 'e'
                                                );

                                            const MDEntryPxe =
                                                mdEntrye?.MDEntryPx ?? null;

                                            let cierreAnterior =
                                                MDEntryPxe
                                                    ? MDEntryPxe
                                                    : '0';

                                            cierreAnterior =
                                                cierreAnterior
                                                    .toString()
                                                    .replace(/\./g, '');

                                            cierreAnterior =
                                                cierreAnterior
                                                    .toString()
                                                    .replace(/,/g, '.');

                                            cierreAnterior =
                                                Number(cierreAnterior).toFixed(2);


                                            let variacionAnterior =
                                                (
                                                    Number(ultimoPrecio) /
                                                    Number(cierreAnterior)
                                                ) - 1;

                                            species.previousVariacion =
                                                variacionAnterior.toFixed(2);


                                            /*
                                             * Actualizamos solamente
                                             * el elemento correspondiente.
                                             */
                                            Object.assign(
                                                entryToUpdate,
                                                priceListItem
                                            );


                                            if (
                                                priceListItem.MDEntryPositionNo ===
                                                1
                                            ) {
                                                shouldUpdatePrices = true;
                                            }

                                        }

                                    }

                                    break;


                                default:

                                    console.warn(
                                        'MDUpdateAction no reconocido:',
                                        priceListItem.MDUpdateAction,
                                        priceListItem
                                    );

                                    break;
                            }


                        } else {

                            /*
                             * No existe todavía el grupo 0/1.
                             *
                             * IMPORTANTE:
                             * usamos la acción del priceListItem.
                             */
                            if (mdUpdateAction === 0) {

                                const newGroup = {

                                    MDEntryType: mDEntryType,

                                    MDUpdateAction:
                                        priceListItem.MDUpdateAction,

                                    /*
                                     * Solamente agregamos este item,
                                     * no todo newEntry.priceList.
                                     */
                                    priceList: [
                                        {
                                            ...priceListItem
                                        }
                                    ]
                                };

                                species.NoMDEntries.push(newGroup);

                                shouldUpdatePrices = true;
                            }
                        }
                    }
                });

            } else {

                // Handle other MDEntryTypes

                // En Cauciones (QS), algunos MDEntryTypes como "2"
                // no traen SecurityID dentro del entry.
                // El SecurityID viene a nivel del mensaje FIX.

                const securityId =
                    newEntry.SecurityID ??
                    newPrice.SecurityID;

                const species = arrayPrices.find(
                    species => species.SecurityID === securityId
                );

                if (species) {

                    species.time = new Date().toLocaleTimeString();

                    // El último precio también viene informado
                    // a nivel del mensaje FIX.
                    if (
                        newPrice.lastMdEntryPx !== undefined &&
                        newPrice.lastMdEntryPx !== null
                    ) {
                        species.lastMdEntryPx =
                            newPrice.lastMdEntryPx;
                    }

                    const existingEntry =
                        species.NoMDEntries.find(
                            entry =>
                                entry.MDEntryType === mDEntryType
                        );

                    if (existingEntry) {

                        existingEntry.previousMDEntryPx =
                            existingEntry.MDEntryPx;

                        existingEntry.previousMDEntrySize =
                            existingEntry.MDEntrySize;

                        Object.assign(
                            existingEntry,
                            newEntry
                        );

                    } else {

                        species.NoMDEntries.push({
                            ...newEntry
                        });
                    }

                    shouldUpdatePrices = true;
                }
            }
        });


        if (shouldUpdatePrices) {
            setPrices([...arrayPrices]);
        }
    };


    const viewPrice = (securityType, boxs, cod) => {
        setPrices([]);
        pricesRef.current = [];
        setCode(cod);
        fix.prices(securityType).then((response) => {
            const pricesResponse = response.data;
            let prices = [];
            for (let p = 0; p < pricesResponse.length; p++) {
                for (let a = 0; a < pricesResponse[p].subTabs.length; a++) {
                    for (let a1 = 0; a1 < boxs.length; a1++) {
                        if (boxs[a1] === pricesResponse[p].subTabs[a].nameSubTab) {
                            for (let b = 0; b < pricesResponse[p].subTabs[a].especies.length; b++) {
                                let especie = pricesResponse[p].subTabs[a].especies[b];
                                especie.time = new Date().toLocaleTimeString();
                                prices.push(especie);
                            }
                        }
                    }
                }
            }

            let pricesFlag = ordenarDatos(prices);
            setList(pricesFlag);
            setPrices(pricesFlag);
        })
    }

    const dayResults = () => {

        const request = {
            "clOrdID": "1",
            "partyID": "dmx220-3",
            "partyIDSource": "D",
            "partyRole": "53",
            "orderBook": "1"
        };

        const instance = user.data.instance;
        const client = constants.CLIENT;

        fixCon.tradeCaptureReportRequest(client, instance, request).then((response) => {
            const tradeCaptureResponse = response.data;
            let res = [];
            for (let p = 0; p < tradeCaptureResponse.length; p++) {
                if (tradeCaptureResponse[p]['39'] === '1' || tradeCaptureResponse[p]['39'] === '2') {
                    res.push(tradeCaptureResponse[p]);
                }
            }
            setResults(res);
        }).catch((error) => {
            console.log(error)
        })
    }

    const saldosFc = () => {

        const user = AuthService.getCurrentUser();
        let dueDateFlag = new Date();
        let dueDate = formatDate(dueDateFlag);

        let where = filterByTradeAccountIdManagerId();
        informationService.storeProcedurePosition('positionBalanceAsOf', user.data.instance, dueDate, where).then((response) => {
            if (response.data)
                setSaldos(response.data);
        })
    }

    const disponiblesFc = (itemPropertyIdParam, setType) => {
        const user = AuthService.getCurrentUser();

        let diasPlazo = Number(setType) - 1;
        let dateParam = new Date();
        dateParam.setDate(dateParam.getDate() + diasPlazo);
        let dateParam1 = formatDate(dateParam);

        let entityPropertyIdParam = user.data.entityPropertyId;

        informationService.storeProcedureEntityHoldingAvailableAsOf('entityHoldingAvailableAsOf', user.data.instance, dateParam1, entityPropertyIdParam, itemPropertyIdParam).then((response) => {
            setDisponibles(response.data);
        });
    }

    const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    const filterByTradeAccountIdManagerId = () => {
        const user = AuthService.getCurrentUser();
        let whereFieldParam = [];

        if (user.data.companyId) {
            whereFieldParam.push({
                idField: 'companyId',
                operator: '=',
                value: user.data.companyId
            })
        } else {
            whereFieldParam.push({
                idField: 'companyId',
                operator: '=',
                value: null
            })
        }

        if (user.data.tradeAccountId) {
            whereFieldParam.push({
                idField: 'tradeAccountId',
                operator: '=',
                value: user.data.tradeAccountId
            })
        } else {
            whereFieldParam.push({
                idField: 'tradeAccountId',
                operator: '=',
                value: null
            })
        }

        if (user.data.managerId) {
            whereFieldParam.push({
                idField: 'managerId',
                operator: '=',
                value: user.data.managerId
            })
        } else {
            whereFieldParam.push({
                idField: 'managerId',
                operator: '=',
                value: null
            })
        }
        return whereFieldParam;
    }

    const ordenarDatos = (data) => {
        if (!Array.isArray(data)) return [];

        return [...data].sort((a, b) => {
            // 1️⃣ Ordenar por Symbol (ascendente)
            const symbolCompare = a.Symbol?.localeCompare(b.Symbol ?? "") ?? 0;
            if (symbolCompare !== 0) return symbolCompare;

            // 2️⃣ Si el Symbol es igual, ordenar por SettlType del primer elemento de NoMDEntries
            const settlA = a.NoMDEntries?.[0]?.SettlType ?? 0;
            const settlB = b.NoMDEntries?.[0]?.SettlType ?? 0;
            return settlA - settlB;
        });
    };

    const handleFilterCdo = () => {
        setTipoVencimientoCdo(!tipoVencimientoCdo);
    }

    const handleFilter24 = () => {
        setTipoVencimiento24(!tipoVencimiento24);
    }

    const handleFilterPrecio = () => {
        setPrecioFiltro(!precioFiltro);
    }

    const handleFieldFilterChange = (e, idField) => {
        let value = e.target.value;
        fieldFilter = {
            id: value
        }

        let newFiltersValues = filtersValues.filter(filter => filter.idField !== idField);

        if (value !== "") {
            newFiltersValues = [...newFiltersValues, { idField, value }];
        }
        setFiltersValues(newFiltersValues);

        const updatedFiltersValues = [...newFiltersValues];

        if (updatedFiltersValues.length > 0) {
            let pricesFlag = JSON.parse(JSON.stringify(list));
            for (let r = 0; r < list.length; r++) {
                let especies = [];
                for (let r = 0; r < list.length; r++) {
                    let matchesAllFilters = true;
                    for (let h = 0; h < updatedFiltersValues.length; h++) {

                        if (updatedFiltersValues[h].idField === 'SettlType') {
                            let valueEspecie = 'C.I.';
                            let SettlTypeFlag = list[r].NoMDEntries[0].SettlType;
                            if (Number(SettlTypeFlag) === 2) {
                                valueEspecie = '24hs';
                            }
                            if (!valueEspecie.includes(updatedFiltersValues[h].value.toUpperCase())) {
                                matchesAllFilters = false;
                                break;
                            }
                        } else {

                            if (list[r][updatedFiltersValues[h].idField]) {

                                let valueEspecie = list[r][updatedFiltersValues[h].idField].toUpperCase();
                                if (updatedFiltersValues[h].idField === 'SecurityID') {
                                    valueEspecie = '-';
                                    let sec = list[r].SecurityID.split('-');
                                    if (sec.length > 3) {
                                        valueEspecie = sec[4];
                                    }
                                }

                                if (!valueEspecie.includes(updatedFiltersValues[h].value.toUpperCase())) {
                                    matchesAllFilters = false;
                                    break;
                                }

                            } else {
                                matchesAllFilters = false;
                                break;
                            }
                        }
                    }
                    if (matchesAllFilters) {
                        especies.push(list[r])
                    }
                }
                pricesFlag = especies;
            }
            setPrices(pricesFlag);
        } else {
            let arrayFlag = [];
            for (let r = 0; r < list.length; r++) {
                arrayFlag.push(list[r]);
            }
            setPrices(arrayFlag);
        }
    }

    const calcularVtoCaucion = (securityId) => {
        if (!securityId) return null;

        // El vencimiento de Cauciones viene en SecurityID como DDMM.
        // Ej: DOLAR-0912-U-CT-USD -> 0912
        const match = String(securityId).match(/(?:^|-)\d{0,}?(\d{4})(?:-|$)/);
        if (!match) return null;

        const ddmm = match[1];
        const dia = Number(ddmm.substring(0, 2));
        const mes = Number(ddmm.substring(2, 4));

        if (dia < 1 || dia > 31 || mes < 1 || mes > 12) return null;

        const hoy = new Date();
        hoy.setHours(0, 0, 0, 0);

        let anio = hoy.getFullYear();
        let fechaVto = new Date(anio, mes - 1, dia);
        fechaVto.setHours(0, 0, 0, 0);

        // Si la fecha ya pasó (o es hoy), corresponde al año siguiente.
        if (fechaVto <= hoy) {
            anio += 1;
            fechaVto = new Date(anio, mes - 1, dia);
            fechaVto.setHours(0, 0, 0, 0);
        }

        // Validamos que JS no haya corregido una fecha inválida.
        if (
            fechaVto.getFullYear() !== anio ||
            fechaVto.getMonth() !== mes - 1 ||
            fechaVto.getDate() !== dia
        ) {
            return null;
        }

        return {
            fecha: fechaVto,
            texto: `${String(dia).padStart(2, '0')}/${String(mes).padStart(2, '0')}/${anio}`
        };
    };

    const calcularPlazoCaucion = (fechaVto) => {
        if (!fechaVto) return '';

        const hoy = new Date();
        hoy.setHours(0, 0, 0, 0);

        const diferencia = fechaVto.getTime() - hoy.getTime();

        return Math.round(diferencia / (1000 * 60 * 60 * 24));
    };

    const formatNumber = (value, isDecimal) => {
        if (value == null || isNaN(value)) return '-';

        const [integerPart, decimalPart = ''] = value.toString().split('.');
        const withThousands = Number(integerPart).toLocaleString('de-DE'); // separador miles con punto

        let formattedDecimals;
        if (decimalPart.length === 0) {
            formattedDecimals = '00';
        } else if (decimalPart.length === 1) {
            formattedDecimals = `${decimalPart}0`;
        } else {
            formattedDecimals = decimalPart;
        }
        if (!isDecimal)
            return `${withThousands}`;
        else
            return `${withThousands},${formattedDecimals}`;
    };

    const updateInfoMercado = (symbol, vto, setType, variacion) => {

        setTittleInfoMercado(`${symbol}-${vto}`);


        let arrayCompras = [];
        let arrayVentas = [];
        prices.forEach((itemPrices, index) => {

            if (itemPrices.Symbol === symbol) {

                itemPrices.NoMDEntries.forEach((itemNoMDEntries) => {
                    if (itemNoMDEntries.priceList) {
                        itemNoMDEntries.priceList.forEach((itemPriceList) => {
                            if (Number(itemPriceList.SettlType) === Number(setType)) {

                                if (Number(itemNoMDEntries.MDEntryType) === 0) {
                                    arrayCompras.push({
                                        'cCompra': itemPriceList.MDEntrySize,
                                        'pCompra': itemPriceList.MDEntryPx
                                    })
                                }
                                if (Number(itemNoMDEntries.MDEntryType) === 1) {
                                    arrayVentas.push({
                                        'cVenta': itemPriceList.MDEntrySize,
                                        'pVenta': itemPriceList.MDEntryPx
                                    })
                                }

                                setUltPrecio(itemPrices.lastMdEntryPx);
                                setVariac(variacion);
                                setSelectSymbol({
                                    id: index,
                                    label: itemPrices.Symbol,
                                    securityType: itemPrices.SecurityType,
                                    securityID: itemPrices.SecurityID,
                                    factor: itemPrices.Factor,
                                });
                            }
                        })
                    }
                })
            }
        })

        const max = Math.max(arrayCompras.length, arrayVentas.length);

        const arrayResponse = [];

        for (let i = 0; i < max; i++) {

            arrayResponse.push({

                cCompra: arrayCompras[i]?.cCompra ?? "",

                pCompra: arrayCompras[i]?.pCompra ?? "",

                cVenta: arrayVentas[i]?.cVenta ?? "",

                pVenta: arrayVentas[i]?.pVenta ?? ""

            });

        }

        setListInfoMercado(arrayResponse);
    }

    const handleSelectSymbolChange = (newValue) => {

        if (newValue) {
            let vto = '-';
            let setType = newValue.settlType;
            if (setType === 1)
                vto = "C.I.";
            if (setType === 2)
                vto = "24hs";
            updateInfoMercado(newValue.label, vto, setType, 0)

            disponiblesFc(newValue.label, setType);
        }
    };

    const handleSelectSymbolChangeRow = (symbol, vto, setType, variacion, item) => {
        updateInfoMercado(symbol, vto, setType, variacion)

        disponiblesFc(symbol, setType);

    };

    return (
        <ThemeProvider theme={constants.CUSTOM_MUI_GENERAL_THEME}>
            <div className="App">
                <CssBaseline />
                <header className="App-header">
                    <Box ref={boxRef} sx={{ width: "100%", flexGrow: 1 }}>
                        <Grid container xs={12} item>
                            <ThemeProvider theme={constants.CUSTOM_MUI_TEXT_FIELD_THEME}>
                                <Box sx={{ width: '100%' }}>
                                    <MenuApp />
                                    <Grid container sx={{ m: 1 }} xs={12} item>
                                        <Grid item xs={9}>
                                            <Box
                                                border={1}
                                                borderColor="rgb(0 0 0 / 13%)"
                                                borderRadius="4px"
                                                p={2}
                                                padding={1}
                                                sx={{
                                                    height: "auto",        // 👈 dejalo crecer naturalmente
                                                    overflow: "visible",   // 👈 aseguramos que no corte nada
                                                    marginTop: 8,
                                                }}
                                            >
                                                <Typography
                                                    sx={{
                                                        //mt: 4,
                                                        mb: 2,
                                                    }}
                                                    variant="h6"
                                                    component="div"
                                                >
                                                    Cotizaciones
                                                </Typography>
                                                <Divider style={{ marginTop: '10px', marginBottom: '10px' }} />
                                                <Box
                                                    sx={{
                                                        position: "sticky",
                                                        top: 0,
                                                        zIndex: 10,
                                                        backgroundColor: "white",
                                                        display: "flex",
                                                        flexDirection: "row",
                                                        alignItems: "center",
                                                        gap: 1,
                                                        borderBottom: "1px solid rgb(0 0 0 / 13%)",
                                                        p: 1
                                                    }}
                                                >
                                                    <Button
                                                        color="primary"
                                                        variant={code === 'CS' ? 'contained' : 'outlined'}
                                                        sx={{ height: 32, minWidth: 50, fontSize: '10px' }}
                                                        onClick={() => viewPrice('CS', ['Merval-Lideres'], 'CS')}
                                                    >
                                                        Líderes
                                                    </Button>

                                                    <Button
                                                        color="primary"
                                                        variant={code === 'CS1' ? 'contained' : 'outlined'}
                                                        sx={{ height: 32, minWidth: 50, fontSize: '10px' }}
                                                        onClick={() => viewPrice('CS', ['General', ''], 'CS1')}
                                                    >
                                                        General
                                                    </Button>

                                                    <Button
                                                        color="primary"
                                                        variant={code === 'OPT' ? 'contained' : 'outlined'}
                                                        sx={{ height: 32, minWidth: 50, fontSize: '10px' }}
                                                        onClick={() => viewPrice('OPT', [''], 'OPT')}
                                                    >
                                                        Opciones
                                                    </Button>

                                                    <Button
                                                        color="primary"
                                                        variant={code === 'CD' ? 'contained' : 'outlined'}
                                                        sx={{ height: 32, minWidth: 50, fontSize: '10px' }}
                                                        onClick={() => viewPrice('CD', [''], 'CD')}
                                                    >
                                                        Cedear
                                                    </Button>

                                                    <Button
                                                        color="primary"
                                                        variant={code === 'GO' ? 'contained' : 'outlined'}
                                                        sx={{ height: 32, minWidth: 50, fontSize: '10px' }}
                                                        onClick={() => viewPrice('GO', [''], 'GO')}
                                                    >
                                                        Bonos
                                                    </Button>

                                                    <Button
                                                        color="primary"
                                                        variant={code === 'GO1' ? 'contained' : 'outlined'}
                                                        sx={{ height: 32, minWidth: 50, fontSize: '10px' }}
                                                        onClick={() => viewPrice('GO', ['Letes'], 'GO1')}
                                                    >
                                                        Letras
                                                    </Button>

                                                    <Button
                                                        color="primary"
                                                        variant={code === 'CORP' ? 'contained' : 'outlined'}
                                                        sx={{ height: 32, minWidth: 50, fontSize: '10px' }}
                                                        onClick={() => viewPrice('CORP', ['Oblig. Negociables Cortas', ''], 'CORP')}
                                                    >
                                                        ON
                                                    </Button>

                                                    <Button
                                                        color="primary"
                                                        variant={code === 'QS' ? 'contained' : 'outlined'}
                                                        sx={{ height: 32, minWidth: 50, fontSize: '10px' }}
                                                        onClick={() => viewPrice('QS', [''], 'QS')}
                                                    >
                                                        Cauciones
                                                    </Button>

                                                    <Button
                                                        color="primary"
                                                        variant={code === 'FUT' ? 'contained' : 'outlined'}
                                                        sx={{ height: 32, minWidth: 50, fontSize: '10px' }}
                                                        onClick={() => viewPrice('FUT', ['Indice Merval'], 'FUT')}
                                                    >
                                                        Índices
                                                    </Button>

                                                    <Button
                                                        color="primary"
                                                        variant={code === 'FUT1' ? 'contained' : 'outlined'}
                                                        sx={{ height: 32, minWidth: 50, fontSize: '10px' }}
                                                        onClick={() => viewPrice('FUT', ['Dólar', 'Dólar pase', 'Real'], 'FUT1')}
                                                    >
                                                        Futuros
                                                    </Button>

                                                    <Box sx={{ display: "flex", gap: 1, ml: "auto" }}>
                                                        <Button
                                                            color="secondary"
                                                            variant={tipoVencimientoCdo ? 'contained' : 'outlined'}
                                                            sx={{ height: 32, width: 30, fontSize: '10px' }}
                                                            onClick={handleFilterCdo}
                                                        >
                                                            Cdo
                                                        </Button>

                                                        <Button
                                                            color="secondary"
                                                            variant={tipoVencimiento24 ? 'contained' : 'outlined'}
                                                            sx={{ height: 32, width: 30, fontSize: '10px' }}
                                                            onClick={handleFilter24}
                                                        >
                                                            24hs
                                                        </Button>

                                                        <Button
                                                            color="secondary"
                                                            variant={precioFiltro ? 'contained' : 'outlined'}
                                                            sx={{ height: 32, minWidth: 80, fontSize: '10px' }}
                                                            onClick={handleFilterPrecio}
                                                        >
                                                            Con Precio
                                                        </Button>
                                                    </Box>
                                                </Box>

                                                <Box
                                                    border={1}
                                                    borderColor="rgb(0 0 0 / 13%)"
                                                    mt={1}
                                                    borderRadius="4px"
                                                    p={1}
                                                >
                                                    <TableContainer
                                                        component={Paper}
                                                        sx={{
                                                            maxHeight: "70vh", // 👈 el scroll solo se aplica acá
                                                            overflowY: "auto",
                                                            maxWidth: "100%",
                                                            margin: "auto"
                                                        }}
                                                    >
                                                        <Table /*stickyHeader*/>
                                                            <TableHead
                                                                sx={{
                                                                    position: "sticky",
                                                                    top: 0,
                                                                    backgroundColor: "white",
                                                                    zIndex: 2 // Asegura que el encabezado se mantenga sobre las filas
                                                                }}
                                                            >
                                                                <TableRow>
                                                                    <TableCell style={{ width: '10ch' }}>
                                                                        <TextField
                                                                            value={fieldFilter.Symbol}
                                                                            onChange={(event) => handleFieldFilterChange(event, `Symbol`)}
                                                                            InputProps={{
                                                                                style: {
                                                                                    height: '30px',
                                                                                    fontSize: "inherit", lineHeight: "inherit",
                                                                                }
                                                                            }}
                                                                        />
                                                                    </TableCell>
                                                                    <TableCell style={{ width: '10ch' }}>
                                                                        <TextField
                                                                            value={fieldFilter.setType}
                                                                            onChange={(event) => handleFieldFilterChange(event, `SettlType`)}
                                                                            InputProps={{
                                                                                style: {
                                                                                    height: '30px',
                                                                                    fontSize: "inherit", lineHeight: "inherit"
                                                                                }
                                                                            }}
                                                                        />
                                                                    </TableCell>
                                                                    <TableCell style={{ width: '10ch' }}>
                                                                        <TextField
                                                                            value={fieldFilter.currency}
                                                                            onChange={(event) => handleFieldFilterChange(event, `SecurityID`)}
                                                                            InputProps={{
                                                                                style: {
                                                                                    height: '30px',
                                                                                    fontSize: "inherit", lineHeight: "inherit"
                                                                                }
                                                                            }}
                                                                        />
                                                                    </TableCell>
                                                                    {Array.from({ length: code === 'QS' ? 8 : 16 }).map((_, index) => (
                                                                        <TableCell key={`filter-empty-${index}`}></TableCell>
                                                                    ))}
                                                                </TableRow>
                                                                <TableRow sx={{ position: 'sticky', top: 0, zIndex: 5, backgroundColor: 'rgb(50 59 152)' }}>
                                                                    {(code === 'QS' ? titleCauciones : title).map((titleItem, index) => (
                                                                        <TableCell
                                                                            key={titleItem}
                                                                            style={{ color: 'white', textAlign: index > 2 ? 'center' : 'left' }}
                                                                        >
                                                                            <b>{titleItem}</b>
                                                                        </TableCell>
                                                                    ))}
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {
                                                                    prices.map((item, index) => {
                                                                        let currency = '-';
                                                                        let sec = item.SecurityID.split('-');
                                                                        if (sec.length > 3) {
                                                                            currency = sec[4];
                                                                        }

                                                                        let vto = '-';
                                                                        let setType = item.NoMDEntries[0].SettlType;
                                                                        if (setType === 1)
                                                                            vto = "C.I.";
                                                                        if (setType === 2)
                                                                            vto = "24hs";

                                                                        const mdEntry = item.NoMDEntries.find((e) => e.MDEntryType === '0');
                                                                        const previousMDEntrySize = mdEntry?.priceList?.[0]?.previousMDEntrySize ?? null;
                                                                        const MDEntrySize = mdEntry?.priceList?.[0]?.MDEntrySize ?? null;

                                                                        const previousMDEntryPx = mdEntry?.priceList?.[0]?.previousMDEntryPx ?? null;
                                                                        const MDEntryPx = mdEntry?.priceList?.[0]?.MDEntryPx ?? null;

                                                                        const mdEntry0 = item.NoMDEntries.find((e) => e.MDEntryType === '1');
                                                                        const previousMDEntryPx0 = mdEntry0?.priceList?.[0]?.previousMDEntryPx ?? null;
                                                                        const MDEntryPx0 = mdEntry0?.priceList?.[0]?.MDEntryPx ?? null;

                                                                        const previousMDEntrySize0 = mdEntry0?.priceList?.[0]?.previousMDEntrySize ?? null;
                                                                        const MDEntrySize0 = mdEntry0?.priceList?.[0]?.MDEntrySize ?? null;

                                                                        const mdEntry4 = item.NoMDEntries.find((e) => e.MDEntryType === '4');
                                                                        const previousMDEntryPx4 = mdEntry4?.previousMDEntryPx ?? null;
                                                                        const MDEntryPx4 = mdEntry4?.MDEntryPx ?? null;

                                                                        const mdEntry8 = item.NoMDEntries.find((e) => e.MDEntryType === '8');
                                                                        const previousMDEntryPx8 = mdEntry8?.previousMDEntryPx ?? null;
                                                                        const MDEntryPx8 = mdEntry8?.MDEntryPx ?? null;

                                                                        const mdEntry7 = item.NoMDEntries.find((e) => e.MDEntryType === '7');
                                                                        const previousMDEntryPx7 = mdEntry7?.previousMDEntryPx ?? null;
                                                                        const MDEntryPx7 = mdEntry7?.MDEntryPx ?? null;

                                                                        const mdEntrye = item.NoMDEntries.find((e) => e.MDEntryType === 'e');
                                                                        const previousMDEntryPxe = mdEntrye?.previousMDEntryPx ?? null;
                                                                        const MDEntryPxe = mdEntrye?.MDEntryPx ?? null;

                                                                        //CIERRE
                                                                        const mdEntry5 = item.NoMDEntries.find((e) => e.MDEntryType === '5');
                                                                        const previousMDEntryPx5 = mdEntry5?.previousMDEntryPx ?? null;
                                                                        const MDEntryPx5 = mdEntry5?.MDEntryPx ?? null;
                                                                        //CIERRE

                                                                        const mdEntryB = item.NoMDEntries.find((e) => e.MDEntryType === 'B');
                                                                        const previousMDEntrySizeB = mdEntryB?.previousMDEntrySize ?? null;
                                                                        const MDEntrySizeB = mdEntryB?.MDEntrySize ?? null;

                                                                        const previousMDEntryPxB = mdEntryB?.previousMDEntryPx ?? null;
                                                                        const MDEntryPxB = mdEntryB?.MDEntryPx ?? null;

                                                                        const mdEntry9 = item.NoMDEntries.find((e) => e.MDEntryType === '9');
                                                                        const previousMDEntryPx9 = mdEntry9?.previousMDEntryPx ?? null;
                                                                        const MDEntryPx9 = mdEntry9?.MDEntryPx ?? null;

                                                                        //MODIFICACION 03092026
                                                                        const mdEntry2 = item.NoMDEntries.find((e) => e.MDEntryType === '2');
                                                                        const ultimoFlag = mdEntry2?.MDEntryPx ?? 0;
                                                                        //MODIFICACION 03092026

                                                                        // Datos específicos de Cauciones (QS)
                                                                        const mdEntryTrade = item.NoMDEntries.find((e) => e.MDEntryType === '2');
                                                                        const tradePrice = mdEntryTrade?.MDEntryPx ?? mdEntryTrade?.priceList?.[0]?.MDEntryPx ?? null;
                                                                        const mdEntryBid = item.NoMDEntries.find((e) => e.MDEntryType === '0');
                                                                        const mdEntryOffer = item.NoMDEntries.find((e) => e.MDEntryType === '1');
                                                                        const bidPrice = mdEntryBid?.priceList?.[0]?.MDEntryPx ?? null;
                                                                        const bidSize = mdEntryBid?.priceList?.[0]?.MDEntrySize ?? null;
                                                                        const offerPrice = mdEntryOffer?.priceList?.[0]?.MDEntryPx ?? null;
                                                                        const offerSize = mdEntryOffer?.priceList?.[0]?.MDEntrySize ?? null;
                                                                        const mdEntryVwap = item.NoMDEntries.find((e) => e.MDEntryType === '9');
                                                                        const vwapPrice = mdEntryVwap?.MDEntryPx ?? mdEntryVwap?.priceList?.[0]?.MDEntryPx ?? null;

                                                                        // Cauciones: el vencimiento se obtiene del DDMM del Symbol.
                                                                        // Si esa fecha ya pasó, se toma el mismo DDMM del año siguiente.
                                                                        const datosVtoCaucion = calcularVtoCaucion(item.SecurityID);
                                                                        const vtoCaucion = datosVtoCaucion?.texto ?? '';
                                                                        const plazoCaucion = calcularPlazoCaucion(datosVtoCaucion?.fecha);

                                                                        let validateFiltro = true;

                                                                        if (precioFiltro === true) {
                                                                            if (code === 'QS') {
                                                                                if (tradePrice === null && bidPrice === null && offerPrice === null) {
                                                                                    validateFiltro = false;
                                                                                }
                                                                            } else if (MDEntryPx === null && MDEntryPx0 === null) {
                                                                                validateFiltro = false;
                                                                            }
                                                                        }
                                                                        if (tipoVencimiento24 === true && tipoVencimientoCdo === false) {
                                                                            if (Number(setType) === 1) {
                                                                                validateFiltro = false;
                                                                            }
                                                                        }
                                                                        if (tipoVencimiento24 === false && tipoVencimientoCdo === true) {
                                                                            if (Number(setType) === 2) {
                                                                                validateFiltro = false;
                                                                            }
                                                                        }
                                                                        if (validateFiltro) {
                                                                            let ultimoPrecio = item.lastMdEntryPx ? item.lastMdEntryPx : '0';
                                                                            //ultimoPrecio = ultimoPrecio.toString().replace(/\./g, '');
                                                                            //ultimoPrecio = ultimoPrecio.toString().replace(/,/g, '.');
                                                                            ultimoPrecio = Number(ultimoPrecio).toFixed(2);

                                                                            let cierreAnterior = MDEntryPxe ? MDEntryPxe : '0';
                                                                            //cierreAnterior = cierreAnterior.toString().replace(/\./g, '');
                                                                            //cierreAnterior = cierreAnterior.toString().replace(/,/g, '.');
                                                                            cierreAnterior = Number(cierreAnterior).toFixed(2);

                                                                            let variacion = null;
                                                                            if (MDEntryPx5 !== null) {
                                                                                variacion = (((Number(MDEntryPx5) / Number(cierreAnterior)) - 1) * 100).toFixed(2);
                                                                            } else {
                                                                                variacion = (((Number(ultimoPrecio) / Number(cierreAnterior)) - 1) * 100).toFixed(2);
                                                                            }
                                                                            variacion = (variacion !== undefined && variacion !== null && variacion !== 'NaN' && Number(cierreAnterior) !== 0) ? variacion : '0';

                                                                            let variacionAnterior = item.previousVariacion;

                                                                            if (code === 'QS') {
                                                                                return <TableRow
                                                                                    key={index}
                                                                                    sx={{ cursor: "default" }}
                                                                                >
                                                                                    <TableCell>{currency}</TableCell>
                                                                                    <TableCell style={{ textAlign: 'right', fontVariantNumeric: 'tabular-nums' }}>{plazoCaucion}</TableCell>
                                                                                    <TableCell style={{ textAlign: 'right', fontVariantNumeric: 'tabular-nums' }}>{vtoCaucion}</TableCell>
                                                                                    <TableCell style={{ textAlign: 'right', fontVariantNumeric: 'tabular-nums' }}>{formatNumber(tradePrice, true)}%</TableCell>
                                                                                    <TableCell></TableCell>
                                                                                    <TableCell></TableCell>
                                                                                    <TableCell style={{ textAlign: 'right', fontVariantNumeric: 'tabular-nums' }}>{formatNumber(bidSize, true)}</TableCell>
                                                                                    <TableCell style={{ textAlign: 'right', fontVariantNumeric: 'tabular-nums' }}>{formatNumber(bidPrice, true)}</TableCell>
                                                                                    <TableCell style={{ textAlign: 'right', fontVariantNumeric: 'tabular-nums' }}>{formatNumber(offerPrice, true)}</TableCell>
                                                                                    <TableCell style={{ textAlign: 'right', fontVariantNumeric: 'tabular-nums' }}>{formatNumber(offerSize, true)}</TableCell>
                                                                                    <TableCell style={{ textAlign: 'right', fontVariantNumeric: 'tabular-nums' }}>{formatNumber(vwapPrice, true)}</TableCell>
                                                                                </TableRow>;
                                                                            }

                                                                            return <TableRow sx={{
                                                                                cursor: "pointer",
                                                                                "&:hover": {
                                                                                    backgroundColor: "#e6ffff",
                                                                                }
                                                                            }} key={index} onClick={() => handleSelectSymbolChangeRow(item.Symbol, vto, setType, variacion, item)}>
                                                                                <TableCell>{item.Symbol}</TableCell>
                                                                                <TableCell>{vto}</TableCell>
                                                                                <TableCell>{currency}</TableCell>
                                                                                <PriceCell previousSize={previousMDEntrySize} currentSize={MDEntrySize} isDecimal={false} isFontWeight={false} isQty={true} backgroundColor={'#e6ffe6'} />
                                                                                <PriceCell previousSize={previousMDEntryPx} currentSize={MDEntryPx} isDecimal={true} isFontWeight={true} isQty={false} backgroundColor={'#e6ffe6'} />
                                                                                <PriceCell previousSize={previousMDEntryPx0} currentSize={MDEntryPx0} isDecimal={true} isFontWeight={true} isQty={false} backgroundColor={'#ffe6ff'} />
                                                                                <PriceCell previousSize={previousMDEntrySize0} currentSize={MDEntrySize0} isDecimal={false} isFontWeight={false} isQty={true} backgroundColor={'#ffe6ff'} />
                                                                                <PriceCell previousSize={previousMDEntryPx4} currentSize={MDEntryPx4} isDecimal={true} isFontWeight={false} isQty={false} />
                                                                                <PriceCell previousSize={previousMDEntryPx8} currentSize={MDEntryPx8} isDecimal={true} isFontWeight={false} isQty={false} />
                                                                                <PriceCell previousSize={previousMDEntryPx7} currentSize={MDEntryPx7} isDecimal={true} isFontWeight={false} isQty={false} />
                                                                                <TableCell style={{ fontVariantNumeric: 'tabular-nums', textAlign: 'right' }}>{formatNumber(ultimoFlag, true)}</TableCell>
                                                                                <PriceCell previousSize={previousMDEntryPxe} currentSize={MDEntryPxe} isDecimal={true} isFontWeight={false} isQty={false} />
                                                                                <PriceCell previousSize={previousMDEntryPx5} currentSize={MDEntryPx5} isDecimal={true} isFontWeight={false} isQty={false} />
                                                                                <TableCell style={{ textAlign: 'right' }}>{Number(variacion) > Number(variacionAnterior) ? (
                                                                                    <ArrowUpward style={{ color: "green", fontSize: "1rem", marginLeft: 4 }} />
                                                                                ) : Number(variacion) < Number(variacionAnterior) ? (
                                                                                    <ArrowDownward style={{ color: "red", fontSize: "1rem", marginLeft: 4 }} />
                                                                                ) : <ArrowRightAltRounded style={{ color: "gray", fontSize: "1rem", marginLeft: 4 }} />}</TableCell>
                                                                                <TableCell style={{ fontVariantNumeric: 'tabular-nums', textAlign: 'right', color: `${variacion < 0 ? 'red' : 'green'}` }}>{variacion}%</TableCell>
                                                                                <PriceCell previousSize={previousMDEntrySizeB} currentSize={MDEntrySizeB} isDecimal={true} isFontWeight={false} isQty={false} />
                                                                                <PriceCell previousSize={previousMDEntryPxB} currentSize={MDEntryPxB} isDecimal={true} isFontWeight={false} isQty={false} />
                                                                                <PriceCell previousSize={previousMDEntryPx9} currentSize={MDEntryPx9} isDecimal={true} isFontWeight={false} isQty={false} />
                                                                                <TableCell>{item.time}</TableCell>
                                                                            </TableRow>
                                                                        }
                                                                        return null;
                                                                    })

                                                                }
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                </Box>
                                            </Box>
                                        </Grid>

                                        <Grid item xs={3}>
                                            <Box
                                                border={1}
                                                borderColor="rgb(0 0 0 / 13%)"
                                                borderRadius="4px"
                                                p={2}
                                                sx={{
                                                    position: "sticky",
                                                    top: 20,
                                                    height: "fit-content",
                                                    backgroundColor: "white",
                                                    marginTop: 8,
                                                    fontSize: "inherit",
                                                    fontWeight: '500',
                                                    lineHeight: 'inherit'
                                                }}
                                            >

                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "space-between",
                                                        mb: 2,
                                                        gap: 2, // espacio entre grupos
                                                        backgroundColor: "#f0f0f0",
                                                    }}
                                                >

                                                    {/* Especie */}
                                                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>

                                                        <Box
                                                            sx={{
                                                                //border: "1px solid #ccc",
                                                                //borderRadius: "4px",
                                                                padding: "4px 8px",
                                                                //backgroundColor: "#fafafa",
                                                                minWidth: "60px",
                                                                textAlign: "center",
                                                                fontSize: "inherit",
                                                            }}
                                                        >
                                                            <Typography variant="body2" sx={{ fontWeight: "bold", fontSize: "inherit", }}>
                                                                {titleInfoMercado}
                                                            </Typography>
                                                        </Box>
                                                    </Box>

                                                    {/* Ult. Precio */}
                                                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>

                                                        <Typography variant="body2" sx={{ fontVariantNumeric: 'tabular-nums', fontWeight: "bold", fontSize: "inherit", }}>
                                                            Ult. Precio
                                                        </Typography>
                                                        <Box
                                                            sx={{
                                                                border: "1px solid #ccc",
                                                                borderRadius: "4px",
                                                                padding: "4px 8px",
                                                                //backgroundColor: "#fafafa",
                                                                minWidth: "60px",
                                                                textAlign: "center",
                                                                fontSize: "inherit",
                                                            }}
                                                        >
                                                            {ultPrecio}
                                                        </Box>
                                                    </Box>

                                                    {/* Var */}
                                                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                                        <Typography variant="body2" sx={{ fontWeight: "bold", fontSize: "inherit", }}>
                                                            Var
                                                        </Typography>
                                                        <Box
                                                            sx={{
                                                                border: "1px solid #ccc",
                                                                borderRadius: "4px",
                                                                padding: "4px 8px",
                                                                //backgroundColor: "#fafafa",
                                                                minWidth: "60px",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                                gap: "4px",
                                                                fontSize: "inherit",
                                                                lineHeight: 1, // mantiene altura estable
                                                            }}
                                                        >
                                                            <span style={{ color: `${variac < 0 ? 'red' : 'green'}` }}>{variac}</span>
                                                            <span
                                                                style={{
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    height: "100%",
                                                                }}
                                                            >
                                                                {Number(variac) > 0 ? (
                                                                    <ArrowUpward style={{ color: "green", fontSize: "1rem" }} />
                                                                ) : Number(variac) < 0 ? (
                                                                    <ArrowDownward style={{ color: "red", fontSize: "1rem" }} />
                                                                ) : (
                                                                    <ArrowRightAltRounded style={{ color: "gray", fontSize: "1rem" }} />
                                                                )}
                                                            </span>
                                                        </Box>

                                                    </Box>
                                                </Box>

                                                {/* Tabla */}
                                                <TableContainer component={Paper}>
                                                    <Table size="small">
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell style={{ textAlign: 'center', backgroundColor: '#e6ffe6' }}><b>C.Compra</b></TableCell>
                                                                <TableCell style={{ textAlign: 'center', backgroundColor: '#e6ffe6' }}><b>P.Compra</b></TableCell>
                                                                <TableCell style={{ textAlign: 'center', backgroundColor: '#ffe6ff' }}><b>P.Venta</b></TableCell>
                                                                <TableCell style={{ textAlign: 'center', backgroundColor: '#ffe6ff' }}><b>C.Venta</b></TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {listInfoMercado.map((row, index) => {
                                                                if (index < 5) {
                                                                    return <TableRow key={index}>
                                                                        <TableCell style={{ fontVariantNumeric: 'tabular-nums', textAlign: 'right', backgroundColor: '#e6ffe6' }}>{formatNumber(row.cCompra, false)}</TableCell>
                                                                        <TableCell style={{ fontVariantNumeric: 'tabular-nums', textAlign: 'right', fontWeight: "bold", backgroundColor: '#e6ffe6' }}>{formatNumber(row.pCompra, true)}</TableCell>
                                                                        <TableCell style={{ fontVariantNumeric: 'tabular-nums', textAlign: 'right', fontWeight: "bold", backgroundColor: '#ffe6ff' }}>{formatNumber(row.pVenta, true)}</TableCell>
                                                                        <TableCell style={{ fontVariantNumeric: 'tabular-nums', textAlign: 'right', backgroundColor: '#ffe6ff' }}>{formatNumber(row.cVenta, false)}</TableCell>
                                                                    </TableRow>
                                                                }
                                                                return null;
                                                            })}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </Box>

                                            <Box
                                                border={1}
                                                borderColor="rgb(0 0 0 / 13%)"
                                                borderRadius="4px"
                                                p={2}
                                                sx={{
                                                    position: "sticky",
                                                    top: 20,
                                                    height: "fit-content",
                                                    backgroundColor: "white",
                                                    marginTop: 8,
                                                    fontSize: "inherit",
                                                    fontWeight: '500',
                                                    lineHeight: 'inherit'
                                                }}
                                            >

                                                <TableContainer
                                                    component={Paper}
                                                    sx={{
                                                        mt: 2,
                                                        maxHeight: 600,
                                                        overflowY: "auto"
                                                    }}>
                                                    <Table size="small">
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell style={{ textAlign: 'center', backgroundColor: '#f5f5f5' }}>
                                                                    <b>Saldos</b>
                                                                </TableCell>
                                                                <TableCell style={{ textAlign: 'center', backgroundColor: '#f5f5f5' }}>
                                                                    <b>Estado</b>
                                                                </TableCell>
                                                                <TableCell style={{ textAlign: 'center', backgroundColor: '#f5f5f5' }}>
                                                                    <b>Pesos</b>
                                                                </TableCell>
                                                                <TableCell style={{ textAlign: 'center', backgroundColor: '#f5f5f5' }}>
                                                                    <b>MEP</b>
                                                                </TableCell>
                                                                <TableCell style={{ textAlign: 'center', backgroundColor: '#f5f5f5' }}>
                                                                    <b>CABLE</b>
                                                                </TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {saldos.map((row, index) => {
                                                                return <TableRow key={index}>
                                                                    <TableCell style={{ fontVariantNumeric: 'tabular-nums', textAlign: 'left', backgroundColor: '#e6ffe6' }}></TableCell>
                                                                    <TableCell style={{ fontVariantNumeric: 'tabular-nums', textAlign: 'left', fontWeight: "bold", backgroundColor: '#e6ffe6' }}>{row.status}</TableCell>
                                                                    <TableCell style={{ fontVariantNumeric: 'tabular-nums', textAlign: 'right', fontWeight: "bold", backgroundColor: '#e6ffe6' }}>{formatNumber(row.amount, true)}</TableCell>
                                                                    <TableCell style={{ fontVariantNumeric: 'tabular-nums', textAlign: 'right', fontWeight: "bold", backgroundColor: '#e6ffe6' }}>{formatNumber(row.amountMep, true)}</TableCell>
                                                                    <TableCell style={{ fontVariantNumeric: 'tabular-nums', textAlign: 'right', fontWeight: "bold", backgroundColor: '#e6ffe6' }}>{formatNumber(row.amountCcl, true)}</TableCell>
                                                                </TableRow>
                                                            })}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>

                                            </Box>

                                            <Box
                                                border={1}
                                                borderColor="rgb(0 0 0 / 13%)"
                                                borderRadius="4px"
                                                p={2}
                                                sx={{
                                                    position: "sticky",
                                                    top: 20,
                                                    height: "fit-content",
                                                    backgroundColor: "white",
                                                    marginTop: 8,
                                                    fontSize: "inherit",
                                                    fontWeight: '500',
                                                    lineHeight: 'inherit'
                                                }}
                                            >

                                                <TableContainer
                                                    component={Paper}
                                                    sx={{
                                                        mt: 2,
                                                        maxHeight: 600,
                                                        overflowY: "auto"
                                                    }}>
                                                    <Table size="small">
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell style={{ textAlign: 'center', backgroundColor: '#f5f5f5' }}>
                                                                    <b>Instrumento</b>
                                                                </TableCell>
                                                                <TableCell style={{ textAlign: 'center', backgroundColor: '#f5f5f5' }}>
                                                                    <b>ISIN</b>
                                                                </TableCell>
                                                                <TableCell style={{ textAlign: 'center', backgroundColor: '#f5f5f5' }}>
                                                                    <b>Disponible</b>
                                                                </TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {disponibles.map((row, index) => {
                                                                return <TableRow key={index}>
                                                                    <TableCell style={{ fontVariantNumeric: 'tabular-nums', textAlign: 'left', fontWeight: "bold", backgroundColor: '#e6ffe6' }}>{row.item}</TableCell>
                                                                    <TableCell style={{ fontVariantNumeric: 'tabular-nums', textAlign: 'left', fontWeight: "bold", backgroundColor: '#e6ffe6' }}>{row.isin}</TableCell>
                                                                    <TableCell style={{ fontVariantNumeric: 'tabular-nums', textAlign: 'right', fontWeight: "bold", backgroundColor: '#e6ffe6' }}>{formatNumber(row.qtyHolding, true)}</TableCell>
                                                                </TableRow>
                                                            })}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </Box>

                                            {user.data.tradeAccountId !== null && user.data.managerId === null && (
                                                <Box
                                                    border={1}
                                                    borderColor="rgb(0 0 0 / 13%)"
                                                    borderRadius="4px"
                                                    p={2}
                                                    sx={{
                                                        position: "sticky",
                                                        top: 20,
                                                        height: "fit-content",
                                                        backgroundColor: "white",
                                                        marginTop: 8,
                                                        fontSize: "inherit",
                                                        fontWeight: '500',
                                                        lineHeight: 'inherit'
                                                    }}
                                                >

                                                    <TableContainer
                                                        component={Paper}
                                                        sx={{
                                                            mt: 2,
                                                            maxHeight: 600,
                                                            overflowY: "auto"
                                                        }}>
                                                        <Table size="small">
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell style={{ textAlign: 'center', backgroundColor: '#f5f5f5' }}>
                                                                        <b>Especie</b>
                                                                    </TableCell>
                                                                    <TableCell style={{ textAlign: 'center', backgroundColor: '#f5f5f5' }}>
                                                                        <b>Cantidad</b>
                                                                    </TableCell>
                                                                    <TableCell style={{ textAlign: 'center', backgroundColor: '#f5f5f5' }}>
                                                                        <b>Precio</b>
                                                                    </TableCell>
                                                                    <TableCell style={{ textAlign: 'center', backgroundColor: '#f5f5f5' }}>
                                                                        <b>Ult. Precio</b>
                                                                    </TableCell>
                                                                    <TableCell style={{ textAlign: 'center', backgroundColor: '#f5f5f5' }}>
                                                                        <b>Var. %</b>
                                                                    </TableCell>
                                                                    <TableCell style={{ textAlign: 'center', backgroundColor: '#f5f5f5' }}>
                                                                        <b>Var. $</b>
                                                                    </TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {results.map((row, index) => {
                                                                    return <TableRow key={index}>
                                                                        <TableCell style={{ fontVariantNumeric: 'tabular-nums', textAlign: 'right', backgroundColor: '#e6ffe6' }}>{row['55']}</TableCell>
                                                                        <TableCell style={{ fontVariantNumeric: 'tabular-nums', textAlign: 'right', fontWeight: "bold", backgroundColor: '#e6ffe6' }}>{formatNumber(row['14'], true)}</TableCell>
                                                                        <TableCell style={{ fontVariantNumeric: 'tabular-nums', textAlign: 'right', fontWeight: "bold", backgroundColor: '#e6ffe6' }}>{formatNumber(row['44'], true)}</TableCell>
                                                                    </TableRow>
                                                                })}
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>

                                                </Box>
                                            )}
                                        </Grid>
                                    </Grid>
                                </Box>
                            </ThemeProvider>
                        </Grid>
                    </Box>
                </header>
            </div>
            <FooterOperaciones
                selectSymbol={selectSymbol}
                onSelectSymbolChange={handleSelectSymbolChange}
            />
        </ThemeProvider>
    );
};

export default PriceBoard;
